import React from 'react'
import { settings } from '../../resources'

export default () => {
  if (settings.environment !== 'local') {
    window.location = '/mytui/'
    return
  }
  return (
    <div
      style={{
        marginTop: '200px',
        textAlign: 'center',
        fontSize: '2em',
        fontWeight: 'bold',
      }}
    >
      Page not found, 404
    </div>
  )
}
